const FR = {
  "studio.nav": "Studio LIA",
  "studio.badge": "Version guidée sans IA",
  "studio.title": "Studio LIA",
  "studio.subtitle": "Préparez, structurez et exportez vos contenus dans un atelier privé et guidé.",
  "studio.notice": "Studio LIA fonctionne actuellement comme un atelier guidé sans intelligence artificielle. Les résultats sont créés à partir de vos informations et de modèles prédéfinis.",
  "studio.new": "Créer un projet",
  "studio.empty": "Créez votre premier projet à partir de vos informations et des modèles guidés de Studio LIA.",
  "studio.no_invention": "Ajoutez les informations que vous connaissez. Aucun élément manquant ne sera inventé.",
  "studio.saved": "Votre brouillon est enregistré.",
  "studio.verify": "Vérifiez les informations avant de publier.",
  "studio.future": "Cette fonction sera disponible prochainement avec le moteur LIA. Aucun crédit ne sera débité.",
  "studio.failed": "L’opération a échoué. Votre quota n’a pas été débité.",
  "studio.offline": "Vous êtes hors ligne. Le brouillon reste affiché, mais il ne peut pas être enregistré sur votre compte.",
  "studio.history": "Historique et quota",
  "studio.settings": "Confidentialité",
  "studio.projects": "Projets récents",
  "studio.archived": "Projets archivés",
  "studio.remaining": "actions restantes",
  "studio.engine": "Moteur actif : déterministe",
  "studio.private": "Privé par défaut",
  "studio.create_version": "Créer cette version",
  "studio.preview": "Actualiser l’aperçu",
  "studio.save": "Enregistrer le brouillon",
};

const EN = {
  "studio.nav": "LIA Studio",
  "studio.badge": "Guided version without AI",
  "studio.title": "LIA Studio",
  "studio.subtitle": "Prepare, structure and export content in a private guided workspace.",
  "studio.notice": "LIA Studio currently works as a guided workshop without artificial intelligence. Results are created from your information and predefined templates.",
  "studio.new": "Create a project",
  "studio.empty": "Create your first project from your information and LIA Studio’s guided templates.",
  "studio.no_invention": "Add the information you know. Missing details will not be invented.",
  "studio.saved": "Your draft is saved.",
  "studio.verify": "Check the information before publishing.",
  "studio.future": "This function will be available later with the LIA engine. No credit will be charged.",
  "studio.failed": "The operation failed. Your quota was not charged.",
  "studio.offline": "You are offline. The draft remains visible but cannot be saved to your account.",
  "studio.history": "History and quota",
  "studio.settings": "Privacy",
  "studio.projects": "Recent projects",
  "studio.archived": "Archived projects",
  "studio.remaining": "actions remaining",
  "studio.engine": "Active engine: deterministic",
  "studio.private": "Private by default",
  "studio.create_version": "Create this version",
  "studio.preview": "Refresh preview",
  "studio.save": "Save draft",
};

export const STUDIO_TRANSLATIONS = { fr: FR, en: EN };
